import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { useAdminMfaStatus } from "../hooks/useAdminMfaStatus";
import { OnboardingGate } from "./OnboardingGate";
import { traceAuthTransition } from "../lib/authTransitionTrace";

export function AdminMfaGate() {
  const location = useLocation();
  const { session, loading } = useAuth();
  const { outcome, isLoading, isError } = useAdminMfaStatus(session);
  useEffect(() => {
    traceAuthTransition("mfa_gate", { authenticated: Boolean(session), decision: loading || isLoading ? "loading" : isError ? "error" : outcome?.decision ?? "unknown" });
  }, [session, loading, isLoading, isError, outcome?.decision]);

  if (loading || isLoading) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Laden...</div>;
  }

  if (!session) return <Navigate to="/login" replace />;

  if (isError) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4 text-center text-sm text-red-600">
        Kon de tweefactorstatus niet controleren. Log opnieuw in of neem contact op met je beheerder.
      </div>
    );
  }

  if (outcome?.decision === "require_enroll" || outcome?.decision === "require_challenge") {
    return <Navigate to="/2fa" replace state={location.pathname === "/app/activatiecentrum" ? { activation: true } : null} />;
  }

  if (!outcome) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Laden...</div>;
  }

  return <OnboardingGate />;
}

